const tableHeaders = [
  {
    text: 'Campaign Name',
    value: 'name'
  },
  {
    text: 'AM',
    value: 'AM'
  },
  {
    text: 'CC',
    value: 'CC'
  },
  {
    text: 'Date of Review',
    value: 'reviewMeetingDate'
  },
  {
    text: 'Stats and Sentiment Due Date',
    value: 'sentimentDueDate'
  },
  {
    text: 'Completed by CC',
    value: 'ccDeckReadyDate'
  },
  {
    text: 'Completed by AM',
    value: 'amDeckReadyDate'
  },
  {
    text: 'Alignment Sync',
    value: 'overallAlignmentDate'
  },
  {
    text: 'Approved by Admin',
    value: 'approvedByAdmin'
  },
  {
    text: 'Feedback Form',
    value: 'feedback'
  }
]

const reviewMeetingChecklists = {
  completedByCC: {
    html: `
      <ol class="text-left body-1">
        <li>Analysis of influencer sentiments and feedback</li>
        <li>Analysis of audience sentiments</li>
        <li>Lineup quality and rationale</li>
        <li>Draft Quality</li>
        <li>Timeline Management</li>
        <li>Numbers for this campaign vs other paid campaigns</li>
        <li>Other scenarios that should be addressed</li>
      </ol>
    `
  },
  completedByAM: {
    html: `
      <ol class="text-left body-1">
        <li>Overall content strategy alignment</li>
        <li>Overall creator strategy alignment</li>
        <li>Numbers for this campaign vs Other campaigns</li>
        <li>Content Format Analysis</li>
        <li>Timeline Management</li>
        <li>Client Management</li>
        <li>Any crisis</li>
        <li>Clear Next steps Prescribed </li>
      </ol>
    `
  }
}
export default {
  tableHeaders,
  reviewMeetingChecklists
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/ReviewMeeting/config.js